import { Timer } from "./Time/Timer";



export enum eSlideMessageState {
    slideIn,
    slideOutDelay,
    slideOut,
}



export class SlideMessageSettings {
    get stateTimes(): number[] { return this._stateTimes; }
    private _stateTimes: number[];

    get slideInTime(): number { return this._stateTimes[eSlideMessageState.slideIn]; }
    get slideOutDelay(): number { return this._stateTimes[eSlideMessageState.slideOutDelay]; }
    get slideOutTime(): number { return this._stateTimes[eSlideMessageState.slideOut]; }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    constructor(slideInTime: number, slideOutDelay: number, slideOutTime: number) {
        this._stateTimes = [
            slideInTime,
            slideOutDelay,
            slideOutTime
        ];
    }
}



export abstract class SlideMessageBase {
    get active(): boolean { return this._active; }
    private _active: boolean;

    private _defSettings: SlideMessageSettings;
    private _settings: SlideMessageSettings;
    private _timer: Timer;
    private _state: eSlideMessageState;
    private _stateTime: number;

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    constructor(defSettings?: SlideMessageSettings, timer?: Timer) {
        this._timer = timer;
        this._defSettings = defSettings;

        this._active = false;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    protected abstract updateContainer(state: eSlideMessageState, stateProgress: number): void;

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    reset(): void {
        this._active = false;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    update(): boolean {
        if (!this._active)
            return false;

        let progress = (this._timer.time - this._stateTime) / this._settings.stateTimes[this._state];

        if (progress >= 1)
            progress = 1;

        this.updateContainer(this._state, progress);

        if (progress == 1) {
            if (this._state++ == eSlideMessageState.slideOut) {
                this.reset();
                return false;
            }

            this._stateTime = this._timer.time;
        }

        return true;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    protected showMessage(settings?: SlideMessageSettings, timer?: Timer): void {
        this._settings = (settings ? settings : this._defSettings);

        if (timer)
            this._timer = timer;

        this._active = true;
        this._state = eSlideMessageState.slideIn;
        this._stateTime = this._timer.time;

        this.updateContainer(eSlideMessageState.slideIn, 0);
    }
}